import React from "react";
import { Segment, Header, Button, Modal } from "semantic-ui-react";
import moment from "moment-with-locales-es6";
import { useHistory } from "react-router-dom";
moment.locale("fr");

const CustomModal = (props) => {
	const history = useHistory();
	const { patientName, patientMylabId, acts, start, qrCode, folder, uid } = props;
	const getActs = (acts) => {
		let result = [];
		if (acts.includes("IIU")) result.push("Insémination Intra-Utérine");
		if (acts.includes("SPERM")) result.push("Spermogramme");
		if (acts.includes("PREL")) result.push("Prélèvement");
		if (acts.includes("QCOV")) result.push("COVID Quick PCR");
		return result.join(", ");
	};
	const toCapitalize = (str) => {
		return str.charAt(0).toUpperCase() + str.slice(1);
	};
	return (
		<div>
			<div className="customModal">
				<Header
					as="h3"
					content={`${toCapitalize(moment(start.toDate()).format("dddd DD MMMM"))} à ${moment(start).format("HH:mm")} : Rendez-vous au centre`}
				/>
				<Segment raised>
					{patientName}
					<br />
					{getActs(acts).includes(",") ? "Actes médicaux demandés" : "Acte médical demandé"} : <b>{getActs(acts)}</b>
					{qrCode && <div>Envoi d'un document en pré-inscription </div>}
					{!qrCode && !folder && <div>Pas de document envoyé lors de la prise de rendez-vous.</div>}
					{!qrCode && folder && (
						<div>
							Un dossier a été créé pour ce rendez-vous : Dossier <b>{folder.code}</b>
						</div>
					)}
					<div style={{ display: "flex", justifyContent: "flex-end" }}>
						<div>{qrCode && <Button onClick={(e) => history.push(`/home/lab/preregister_${qrCode}`)}>Voir la demande du patient</Button>}</div>
						<div>{folder && <Button onClick={() => history.push(`/home/foldermanager/${folder.code}`)}>Ouvrir le dossier</Button>}</div>
						<div>
							{!qrCode && !folder && <Button onClick={(e) => history.push(`/home/lab/patient_${patientMylabId}-${uid}`)}>Nouveau dossier</Button>}
						</div>
					</div>
				</Segment>
			</div>
		</div>
	);
};

export default CustomModal;
